import { createReducer } from '@common/redux-utils';
import {
  ContractErrorActionType,
  SetIsLoadingAction,
  SetContractErrorQueryAction,
  SetContractErrorListAction
} from './contract-error.actions';
import { ContractErrorViewModel } from '@models/ContractError';

export interface ContractErrorState {
  readonly isLoading: boolean;
  readonly query?: string | null;
  readonly orderBy?: string;
  readonly orderDirection?: string;
  readonly contractErrorList: Array<ContractErrorViewModel>;
  readonly pageNumber?: number;
  readonly pageSize?: number;
  readonly totalResults?: number;
  readonly pageCount?: number;
}

export const initialContractErrorState: ContractErrorState = {
  isLoading: false,
  query: '',
  orderBy: 'toDoDate',
  orderDirection: 'desc',
  contractErrorList: [],
  pageNumber: 1,
  pageSize: 10,
  totalResults: 0,
  pageCount: 0
};

function handleSetIsLoading(state: ContractErrorState, action: SetIsLoadingAction): ContractErrorState {
  return {
    ...state,
    isLoading: action.isLoading
  };
}

function handleSetContractErrorQuery(
  state: ContractErrorState,
  action: SetContractErrorQueryAction
): ContractErrorState {
  return {
    ...state,
    query: action.query,
    orderBy: action.orderBy,
    orderDirection: action.orderDirection
  };
}

function handleSetContractErrorList(state: ContractErrorState, action: SetContractErrorListAction): ContractErrorState {
  return {
    ...state,
    isLoading: false,
    contractErrorList: action.contractErrorList,
    pageNumber: action.pageNumber,
    pageSize: action.pageSize,
    totalResults: action.totalResults,
    pageCount: action.totalResults <= 0 ? 0 : Math.ceil(action.totalResults / action.pageSize)
  };
}

export const ContractErrorReducer = createReducer<ContractErrorState, ContractErrorActionType>(
  initialContractErrorState,
  {
    [ContractErrorActionType.SetIsLoading]: handleSetIsLoading,
    [ContractErrorActionType.SetContractErrorQuery]: handleSetContractErrorQuery,
    [ContractErrorActionType.SetContractErrorList]: handleSetContractErrorList
  }
);



// WEBPACK FOOTER //
// ./src/contract-error/contract-error.reducer.ts